import React, { useEffect, useState } from 'react'
import LogoutIcon from '@material-ui/icons/ExitToApp';
import classNames from 'classnames'
import { AppBar, Toolbar, Drawer, Divider, Typography, List, CssBaseline, Box, Button, makeStyles, ListItemText, ListItem, ListItemIcon, Menu, MenuItem } from '@material-ui/core'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import { useDispatch, useSelector } from 'react-redux'
import MenuIcon from "@material-ui/icons/Menu"
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown'
import { mainListItems } from './listItems'
import { customTheme } from '../styling'
import LogoBancaSistema from '../images/banca-sistema-logo.svg'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
export const drawerWidth = 260
import Cookies from 'js-cookie'
import axiosInstance from '../axios';
import { enqueueSnackbar } from 'notistack'
import {INTERNAL_SERVER_ERROR_MESSAGE} from '../constants'

const useStyles = makeStyles(theme => ({
  root: {
  display: 'flex',
  overflowX: 'hidden', 
  },
  toolbar: {
  minHeight: 64, // defina uma altura fixa
  paddingRight: 24,
  },
  toolbarOffset: theme.mixins.toolbar, 
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    backgroundColor: 'white',
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    color: customTheme.colors.ui.greyVeryDark,
    marginLeft: 0,
    marginRight: 12,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
    marginTop: '0.5rem'
  },
  drawerPaper: {
    height: '100vh',
    backgroundColor: 'white',
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9)
    },
  },
  userSection: {
    display: 'flex',
    flexDirection: 'row',
    color: 'black',
    marginRight: '1rem'
  },
}))

const AppBarMain = ({ children }) => {
  const classes = useStyles()
  const { drawerOpen } = useSelector((state) => state.ui)
  const history = useHistory()
  const [anchorMenuEl, setAnchorMenuEl] = React.useState(null)
  const openMenu = Boolean(anchorMenuEl)
  const [userDetails, setUserDetails] = useState(null)
  const dispatch = useDispatch()


  const handleClickMenu = (event) => {
    setAnchorMenuEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorMenuEl(null);
  };


  const handleDrawerOpen = () => {
    dispatch({
      type: 'DRAWER_OPEN',
    })

   
  }
  const handleDrawerClose = () => {
    dispatch({
      type: 'DRAWER_CLOSE',
    })
    
  }

  const handleMoreQuota = async () => {
    try {
      const body = {support_request: {
            kind: "more_quota"
      }}
      await axiosInstance.post(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/support_requests`, body)
      enqueueSnackbar({variant:'success', message:'Richiesta inviata correttamente'})
    } catch (error) {
      console.log('error', error)
      enqueueSnackbar({variant:'error', message:INTERNAL_SERVER_ERROR_MESSAGE})
    }finally{
      
    }
    
  }
  

  useEffect(() => {
    axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/user`, {
    }).then((res) => {
      setUserDetails(res.data.payload)
    }).catch(error => {

    })
  }, [])

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="absolute"
        className={classNames(classes.appBar)}
      >
        <Toolbar className={classes.toolbar} style={{ justifyContent: 'right' }}>
         
            
              {!drawerOpen && <Button
                style={{position:'relative', right:'1rem'}}
                color="inherit"
                aria-label="Open drawer"
                onClick={handleDrawerOpen}
                className={classNames(
                  classes.menuButton,

                )}
              >
                <MenuIcon style={{ height: '6vh', width: '3.5vh' }}/>
              </Button>
              }
              {drawerOpen &&
                <Button
                  style={{position:'relative', right:'1rem'}}
                  color="inherit"
                  aria-label="Open drawer"
                  onClick={handleDrawerClose}
                  className={classNames(
                    classes.menuButton,

                  )}
                >
                  <ChevronLeftIcon style={{ color: customTheme.colors.ui.greyVeryDark, height: '6vh', width: '3.5vh'}} />
                </Button>
              }
            

            
              <Typography
                component="h1"
                variant="h6"
                color="inherit"
                noWrap
                className={classes.title}
              >
                <img src={LogoBancaSistema} style={{ height: 46 }} />
              </Typography>

            
         
          <Button
            className={classes.userSection}
            style={{ float: 'right', }}
            onClick={handleClickMenu}
          >
            <Box style={{
              marginRight: '0.5rem',
              width: 26,
              height: 26,
              borderRadius: '50%',         
              display: 'inline-flex',       
              alignItems: 'center',
              justifyContent: 'center',
              background: userDetails?.email?.includes('bancasistema.it') ? '#B91F26' : '#D2AA39',
              color: 'white',
              lineHeight: 1,                
              textTransform: 'uppercase',  
              }}>{userDetails?.first_name.slice(0, 1)}
            </Box>
            
            <Typography id="basic-menu" style={{ marginRight: '0.4rem', }}>
              {userDetails?.first_name} {userDetails?.last_name} </Typography> <KeyboardArrowDown  />
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorMenuEl}
            open={openMenu}
            onClose={handleCloseMenu}
            style={{marginTop:'3rem',}}
            PaperProps={{ elevation: 5, style: { borderRadius: 15 }}}
          >
            <Box style={{padding:'1.5rem', width:'auto'}}>
            <Typography style={{fontWeight:'bold'}}>Funzionalità</Typography>
            <Box style={{display:'grid', gridTemplateColumns: '1.5fr 1fr', marginTop:'1rem', lineHeight:3, fontSize:'1rem', gap:'0 4rem'}}>
              <Box style={{color:!userDetails?.enable_chat && customTheme.colors.ui.grey}}>Chat</Box>
              <Box style={{textDecoration:'underline', color:userDetails?.enable_chat ? customTheme.colors.ui.green : customTheme.colors.ui.red, cursor:'pointer'}} onClick={() => handleMoreQuota()}>{userDetails?.enable_chat ? 'Richiedi upgrade' : 'Richiedi accesso'}</Box>


              <Box style={{color:!userDetails?.enable_chat_mini && customTheme.colors.ui.grey}}>Chat Mini</Box>
              <Box style={{textDecoration:'underline', color:userDetails?.enable_chat_mini ? customTheme.colors.ui.green : customTheme.colors.ui.red, cursor:'pointer'}} onClick={() => handleMoreQuota()}>{userDetails?.enable_chat_mini ? 'Richiedi upgrade' : 'Richiedi accesso'}</Box>


              <Box style={{color:!userDetails?.enable_translation && customTheme.colors.ui.grey}}>Translator (documenti)</Box>
              <Box style={{textDecoration:'underline', color:userDetails?.enable_translation ? customTheme.colors.ui.green : customTheme.colors.ui.red, cursor:'pointer'}} onClick={() => handleMoreQuota()}>{userDetails?.enable_translation ? 'Richiedi upgrade' : 'Richiedi accesso'}</Box>


              <Box style={{color:!userDetails?.enable_translation && customTheme.colors.ui.grey}}>Translator (testo)</Box>
              <Box style={{textDecoration:'underline', color:userDetails?.enable_translation ? customTheme.colors.ui.green : customTheme.colors.ui.red, cursor:'pointer'}} onClick={() => handleMoreQuota()}>{userDetails?.enable_translation ? 'Richiedi upgrade' : 'Richiedi accesso'}</Box>


              <Box style={{color:!userDetails?.enable_audio_tts && customTheme.colors.ui.grey}}>Text to speech</Box>
              <Box style={{textDecoration:'underline', color:userDetails?.enable_audio_tts ? customTheme.colors.ui.green :customTheme.colors.ui.red, cursor:'pointer'}} onClick={() => handleMoreQuota()}>{userDetails?.enable_audio_tts ? 'Richiedi upgrade' : 'Richiedi accesso'}</Box>


              <Box style={{color:!userDetails?.enable_audio_sts && customTheme.colors.ui.grey}}>Speech to Speech</Box>
              <Box style={{textDecoration:'underline', color:userDetails?.enable_audio_sts ? customTheme.colors.ui.green : customTheme.colors.ui.red, cursor:'pointer'}} onClick={() => handleMoreQuota()}>{userDetails?.enable_audio_sts ? 'Richiedi upgrade' : 'Richiedi accesso'}</Box>

              <Box style={{color:!userDetails?.enable_audio_stt && customTheme.colors.ui.grey}}>Speech to Text</Box>
              <Box style={{textDecoration:'underline', color: userDetails?.enable_audio_stt ? customTheme.colors.ui.green : customTheme.colors.ui.red, cursor:'pointer'}} onClick={() => handleMoreQuota()}>{userDetails?.enable_audio_stt ? 'Richiedi upgrade' : 'Richiedi accesso'}</Box>


              <Box style={{color:!userDetails?.enable_image_generator && customTheme.colors.ui.grey}}>AI images</Box>
              <Box style={{textDecoration:'underline', color:userDetails?.enable_image_generator ? customTheme.colors.ui.green : customTheme.colors.ui.red, cursor:'pointer'}} onClick={() => handleMoreQuota()}>{userDetails?.enable_image_generator ? 'Richiedi upgrade' : 'Richiedi accesso'}</Box>

              <Box style={{color:!userDetails?.enable_video_maker && customTheme.colors.ui.grey}}>Video maker</Box>
              <Box style={{textDecoration:'underline', color:userDetails?.enable_video_maker ? customTheme.colors.ui.green : customTheme.colors.ui.red, cursor:'pointer'}} onClick={() => handleMoreQuota()}>{userDetails?.enable_video_maker ? 'Richiedi upgrade' : 'Richiedi accesso'}</Box>

              <Box style={{color:!userDetails?.enable_translation && customTheme.colors.ui.grey}}>Live Translator</Box>
              <Box style={{textDecoration:'underline', color:userDetails?.enable_translation ? customTheme.colors.ui.green : customTheme.colors.ui.red, cursor:'pointer'}} onClick={() => handleMoreQuota()}>{userDetails?.enable_translation ? 'Richiedi upgrade' : 'Richiedi accesso'}</Box>

            </Box>
            </Box>
            

          </Menu>





        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        classes={{
          paper: classNames(classes.drawerPaper, !drawerOpen && classes.drawerPaperClose),
        }}

        open={drawerOpen}
      >
        <div className={classes.toolbarIcon}>
          {drawerOpen &&
            <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              className={classes.title}
              // style={{ textAlign: 'center' }}
            >
              <img src={LogoBancaSistema} style={{ height: 46 }} />
            </Typography>
          }

          <Button onClick={handleDrawerClose}>
            <ChevronLeftIcon style={{ color: customTheme.colors.ui.greyVeryDark, }} />
          </Button>

        </div>

        <List>{mainListItems()}</List>
        <Divider />
        <List style={{ position: 'absolute', bottom: 10, width: '100%', overflowX: 'hidden'}}>
          <ListItem button onClick={() => {
            Cookies.remove('refresh-token')
            localStorage.removeItem('access-token')
            history.push('/login')
          }}>
            <ListItemIcon>
              <LogoutIcon style={{ color: customTheme.colors.ui.red, fontSize: '2rem' }} />
            </ListItemIcon>
            <ListItemText style={{ color: 'black' }} primary="Disconnetti" />
          </ListItem>
        </List>
      </Drawer>
      {children}
    </div>
  )
}

export default AppBarMain